export function isKaizenEmail(email: string): boolean {
  return email.toLowerCase().endsWith('@kaizendataventures.com');
}
